import { render, staticRenderFns } from "./GoodsAdd.vue?vue&type=template&id=589e7cea"
import script from "./GoodsAdd.vue?vue&type=script&lang=js"
export * from "./GoodsAdd.vue?vue&type=script&lang=js"
import style0 from "./GoodsAdd.vue?vue&type=style&index=0&id=589e7cea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports